/**
 * Decimal places used when the server rounds amounts before storing them.
 * Currencies are never stored with more precision than this (the client
 * displays the currency's own decimal places from the startup snapshot); the
 * intent is simply to keep floating-point artifacts (e.g. 10.000002) out of
 * the database.
 */
export const STORAGE_ROUND_DP = 2;

/**
 * Round an amount to the specified number of decimal places.
 * Uses Math.round for deterministic rounding.
 *
 * @param {number | string} amount
 * @param {number} decimalPlaces
 * @returns {number}
 */
export function roundAmount(amount, decimalPlaces) {
	const factor = 10 ** decimalPlaces;
	return Math.round(Number(amount) * factor) / factor;
}
